import amplitude from "amplitude-js";
import { mtLogger } from "shared-core";

import appConfig from "./app";

const noop = () => {};

const hasApiKey = !!import.meta.env.VITE_AMPLITUDE;

if (!hasApiKey) {
  mtLogger.warn("Amplitude — No API key found, analytics disabled.");
}

export const amplitudeInstance: amplitude.AmplitudeClient = hasApiKey
  ? amplitude.getInstance()
  : new Proxy({} as amplitude.AmplitudeClient, {
      get: () => noop,
    });

export const initAmplitude = async (deviceId: string) => {
  // get viewport width and height
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  amplitudeInstance.init(import.meta.env.VITE_AMPLITUDE);
  amplitudeInstance.setDeviceId(deviceId);
  amplitudeInstance.setVersionName(appConfig.BUILD_HASH);

  amplitudeInstance.setUserProperties({
    viewportWidth,
    viewportHeight,
  });
};
